import { gql } from '@apollo/client';

export const SEND_SINGLE_AUTHORIZE_NET_A_TRANSACTION = gql`
mutation sendSingleAuthorizeNetATransaction($token : String!,$paymentdata:CustomerPayment!) {
  sendSingleAuthorizeNetATransaction(token: $token, paymentdata:$paymentdata) {
    status
    data
    error
  }
}
`;

export const SEND_AUTHORIZE_NET_A_VERIFICATION_TRANSACTIONS = gql`
mutation sendAuthorizeNetAVerificationTransactions($phone : String!) {
  sendAuthorizeNetAVerificationTransactions(phone: $phone) {
    status
    data
    error
  }
}
`;

export const CONIFRM_AUTHORIZE_NET_A_VERIFICATION_TRANSACTIONS = gql`
mutation verifyTempAuthorizedNetATransactions($phone : String!, $amount1 : Float!) {
  verifyTempAuthorizedNetATransactions(phone: $phone, amount1: $amount1) {
    status
    data
    error
  }
}
`;